import React from "react";
import { Badge, Tooltip } from "antd";
import PropTypes from "prop-types";
import { FormattedMessage, useIntl, defineMessages } from "react-intl";

import themeColor from "../../lib/style/theme";

const translations = defineMessages({
  licenses: {
    id: "ValidLicenseBadge.licenses",
    defaultMessage: "licenses",
  },
  license: {
    id: "ValidLicenseBadge.license",
    defaultMessage: "license",
  },
  used: {
    id: "ValidLicenseBadge.used",
    defaultMessage: "used",
  },
});

const ValidLicenseBadge = ({ validLicense, licensesUsed }) => {
  const { formatMessage } = useIntl();
  switch (validLicense) {
    case 1:
      return (
        <Tooltip
          title={
            <>
              <FormattedMessage id="ValidLicenseBadge.success" defaultMessage="License is valid" />
            </>
          }
        >
          <Badge
            count={licensesUsed}
            style={{ backgroundColor: themeColor.green }}
            title={`${licensesUsed} ${
              licensesUsed > 1 ? formatMessage(translations.licenses) : formatMessage(translations.license)
            } ${formatMessage(translations.used)}`}
          />
        </Tooltip>
      );
    case 0:
      return (
        <Tooltip
          title={
            <FormattedMessage
              id="ValidLicenseBadge.warning"
              defaultMessage="The license is within 7 days expiry period "
            />
          }
        >
          <Badge
            count={licensesUsed}
            style={{ backgroundColor: themeColor.orange }}
            title={`${licensesUsed} ${
              licensesUsed > 1 ? formatMessage(translations.licenses) : formatMessage(translations.license)
            } ${formatMessage(translations.used)}`}
          />
        </Tooltip>
      );
    case -1:
      return (
        <Tooltip title={<FormattedMessage id="ValidLicenseBadge.error" defaultMessage="License has expired" />}>
          <Badge
            count={licensesUsed}
            style={{ backgroundColor: themeColor.darkRed }}
            title={`${licensesUsed} ${
              licensesUsed > 1 ? formatMessage(translations.licenses) : formatMessage(translations.license)
            } ${formatMessage(translations.used)}`}
          />
        </Tooltip>
      );
    default:
      return (
        <Tooltip title={<FormattedMessage id="ValidLicenseBadge.missingData" defaultMessage="Missing data" />}>
          <Badge count={licensesUsed} style={{ backgroundColor: themeColor.logDebug }} />
        </Tooltip>
      );
  }
};

ValidLicenseBadge.propTypes = {
  validLicense: PropTypes.number.isRequired,
  licensesUsed: PropTypes.number.isRequired,
};

export default ValidLicenseBadge;
